'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('./index.scss');

var _index2 = _interopRequireDefault(_index);

var _advancedFetch = require('./../../advanced-fetch');

var _advancedFetch2 = _interopRequireDefault(_advancedFetch);

var _productType = require('../product-type');

var _productType2 = _interopRequireDefault(_productType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductTypeSelector = function (_React$Component) {
    _inherits(ProductTypeSelector, _React$Component);

    function ProductTypeSelector(props) {
        _classCallCheck(this, ProductTypeSelector);

        var _this = _possibleConstructorReturn(this, (ProductTypeSelector.__proto__ || Object.getPrototypeOf(ProductTypeSelector)).call(this, props));

        _this.state = {
            productTypes: [],
            error: {
                message: '',
                invalidFields: []
            }
        };

        // not part of the state because we it has no effect on the rendering
        _this.data = {
            type: null
        };

        _this.onTypeSelected = _this.onTypeSelected.bind(_this);
        return _this;
    }

    /**
     *
     */


    _createClass(ProductTypeSelector, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.load();
        }

        /**
         * load step information
         */

    }, {
        key: 'load',
        value: function load() {
            var _this2 = this;

            fetch('api/concepta', { credentials: 'include' }).then(_advancedFetch2.default.checkStatus).then(function (response) {
                if (response.next) return _this2.props.history.push(response.next);

                _this2.setState({ productTypes: response.config['product-types'] });
            }).catch(function (err) {
                if (err.status !== 404) void 0;
            });
        }

        /**
         * save step information
         */

    }, {
        key: 'save',
        value: function save() {
            var _this3 = this;

            fetch('api/concepta', {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.data)
            }).then(_advancedFetch2.default.checkStatus).then(function (response) {
                if (response.next) return _this3.props.history.push(response.next);
            }).catch(function (err) {
                if (err.error.status !== 422) {
                    void 0;

                    return;
                }

                _this3.setState(function (prev) {
                    prev.error.message = err.message;
                    prev.error.invalidFields = err.error.invalidFields;

                    return prev;
                });
            });
        }

        /**
         *
         * @returns {*}
         */

    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var error = '';

            if (this.state.error.message) {
                error = _react2.default.createElement(
                    'div',
                    { className: '' + _index2.default.error },
                    this.state.error.message
                );
            }

            return _react2.default.createElement(
                'section',
                { className: '' + _index2.default['comp-product-type-selector'] },
                _react2.default.createElement(
                    'p',
                    null,
                    this.props.t('Please choose:')
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    error
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'grid-x grid-padding-x small-up-1 medium-up-2 large-up-4' },
                    this.state.productTypes.map(function (productType, key) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'cell space-3', key: key },
                            _react2.default.createElement(_productType2.default, {
                                id: productType.key,
                                text: _this4.props.t(productType.label),
                                onClick: function onClick(e) {
                                    return _this4.onTypeSelected(e, productType.key);
                                } })
                        );
                    })
                )
            );
        }

        /**
         *
         * @param e
         * @param type
         */

    }, {
        key: 'onTypeSelected',
        value: function onTypeSelected(e, type) {
            e.preventDefault();

            this.data.type = type;

            this.save();
        }
    }]);

    return ProductTypeSelector;
}(_react2.default.Component);

ProductTypeSelector.propTypes = {
    history: _propTypes2.default.object.isRequired,
    t: _propTypes2.default.func.isRequired

};

exports.default = ProductTypeSelector;


//////////////////
// WEBPACK FOOTER
// ./client/components/product-type-selector/index.js
// module id = 477
// module chunks = 0